import { css } from 'styled-components';

export const ScrollableMixin = css`
    overflow-y: scroll;
    overflow-x: hidden;

    &::-webkit-scrollbar {
        background: transparent;
        width: 0.6rem;
    }

    &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 14px 14px transparent;
        border: solid 4px transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.colors.monochrome.MC2};
        display: block;
        border-radius: 1rem;
        border: 0.2rem solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        -webkit-box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.025);
    }
    &::-webkit-scrollbar-button {
        width: 0;
        height: 0;
        display: none;
    }
    &::-webkit-scrollbar-corner {
        background-color: transparent;
    }
`;

export const calculateIndent = (indent = 0) => (indent ? `${3 * indent}rem` : 0);

export const PredicateRowIndent = css`
    padding-left: ${({ indent }) => calculateIndent(indent)};
`;
